import Swiper from 'swiper'
import { Navigation, Autoplay, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export function initSlideSwiper() {
  new Swiper('.slideSwiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    modules: [Navigation],
    breakpoints: {
      1024: { slidesPerView: 2.5 }
    },
    navigation: {
      nextEl: '.slide-next',
      prevEl: '.slide-prev'
    }
  })
}

export function initFullSlideSwiper() {
  new Swiper('.fullSlideSwiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    modules: [Autoplay, Navigation],

    navigation: {
      nextEl: '.slide-full-next',
      prevEl: '.slide-full-prev'
    }
  })
}

export function initHomeMLMSwiper() {
  new Swiper('.homeMLMSwiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    modules: [Autoplay, Navigation],

    navigation: {
      nextEl: '.HomeMLM-next',
      prevEl: '.HomeMLM-prev'
    }
  })
}
